import { createContext } from 'react'
import { Block, DefaultBlockSchema } from '@packages/blocknote-core'

export const EditorContentContext = createContext<
  Block<DefaultBlockSchema>[] | undefined
>(undefined)

export const EditorContentDispatchContext = createContext<
  React.Dispatch<React.SetStateAction<Block<DefaultBlockSchema>[]>> | undefined
>(undefined)

export const NeedsUploadContext = createContext<boolean>(false)

export const NeedsUploadDispatchContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>> | undefined
>(undefined)
